import { FormPage } from '@omnea-app/packages/universal/formBuilder/form'
import { FormTemplatesInsertInput, FormTemplateStateEnum, FormTypeEnum } from '@omnea-app/packages/universal/hasura/graphql'

export const TprmContinuousMonitoringQuestionIds = {
  tprmContinuousMonitoringMatchCount: 'tprmContinuousMonitoringMatchCount',
  tprmContinuousMonitoringHighestProfileConfidence: 'tprmContinuousMonitoringHighestProfileConfidence',
  tprmContinuousMonitoringHighestHasSanctionCategory: 'tprmContinuousMonitoringHighestHasSanctionCategory',
  tprmContinuousMonitoringHighestHasPepCategory: 'tprmContinuousMonitoringHighestHasPepCategory',
  tprmContinuousMonitoringHighestHasAdverseMediaCategory: 'tprmContinuousMonitoringHighestHasAdverseMediaCategory',
}

// TODO (INT-508): Migrate this to use form template questions to lock down the question IDs
export const formTemplate: FormTemplatesInsertInput = {
  title: 'Risk Screening Report',
  state: FormTemplateStateEnum.PUBLISHED,
  type: FormTypeEnum.EXTERNAL_OPERATION,
  integration: 'tprm-continuous-monitoring',
  description: 'This form is used to capture the output of the Risk Screening Point-in-Time check integration',
  config: {
    logic: {},
    pages: [
      {
        id: '58c141cd-2fa5-4811-a868-384b2db05010',
        name: 'overview',
        title: 'Risk screening results',
        questions: [
          {
            id: '11a791ef-1d6e-4ad9-9684-910fee88c719',
            name: TprmContinuousMonitoringQuestionIds.tprmContinuousMonitoringMatchCount,
            type: 'number',
            title: 'Match count',
            visibleIf: [],
            isRequired: true,
          },
          {
            id: 'f89a3a9b-6e5e-4b37-b3ae-12cfe5be86bf',
            name: TprmContinuousMonitoringQuestionIds.tprmContinuousMonitoringHighestProfileConfidence,
            type: 'number',
            title: 'Highest Profile Confidence (%)',
            visibleIf: [],
            isRequired: true,
          },
          {
            id: '0f47b6aa-e6c2-44c3-aef2-5e29a604fde3',
            name: TprmContinuousMonitoringQuestionIds.tprmContinuousMonitoringHighestHasSanctionCategory,
            type: 'boolean',
            title: 'Sanctions (any profile)',
            visibleIf: [],
            isRequired: true,
          },
          {
            id: 'a768071e-19c1-42cc-853a-deba2a05e6ba',
            name: TprmContinuousMonitoringQuestionIds.tprmContinuousMonitoringHighestHasPepCategory,
            type: 'boolean',
            title: 'PEP (any profile)',
            visibleIf: [],
            isRequired: true,
          },
          {
            id: 'a768071e-19c1-42cc-853a-deba2a05e6bc',
            name: TprmContinuousMonitoringQuestionIds.tprmContinuousMonitoringHighestHasAdverseMediaCategory,
            type: 'boolean',
            title: 'Adverse media (any profile)',
            visibleIf: [],
            isRequired: true,
          },
        ],
      },
    ],
    enableAiSummary: true,
  },
}

export const TprmContinuousMonitoringQuestionTemplatesArray = formTemplate.config.pages.flatMap(
  (page: FormPage) => page.questions
)
export const TprmContinuousMonitoringQuestionIdsArray = Object.values(TprmContinuousMonitoringQuestionIds)
